import { ActiveFormatsState } from '../models/sh-editor-state.model';

export const INITIAL_ACTIVE_FORMATS: ActiveFormatsState = {
    bold: false,
    italic: false,
    underline: false,
    strike: false,
    bulletList: false,
    orderedList: false,
    link: false
};
